export default __webpack_public_path__ + "static/media/download-alert-close.8d644985.svg";